import wixUsers from 'wix-users';
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {

    if (wixUsers.currentUser.loggedIn) {
        $w('#boxState').changeState('State1')

    } else {
        $w('#boxState').changeState('State2')

    }

    $w('#iptName').onFocus(() => {
        $w('#txtError').hide();

    })

    $w('#iptTelephone').onFocus(() => {
        $w('#txtError').hide();

    })

    $w('#iptEmail').onFocus(() => {
        $w('#txtError').hide();

    })

    $w('#btnWatchClip').onClick(() => {
        if ($w('#iptName').value && $w('#iptEmail').value && $w('#iptTelephone').value) {
            addLogActivity();
            $w('#boxState').changeState('State1')
        } else {
            $w('#txtError').show();
        }

    })
})

async function addLogActivity() {

    let referrer = wixWindow.referrer;
    let deviceType = wixWindow.formFactor; // "Mobile"
    let url = wixLocation.url;
    let description = 'Visit';

    let toInsert = {
        "name": $w('#iptName').value,
        "email": $w('#iptEmail').value,
        "telephone": $w('#iptTelephone').value,
        "referrer": referrer,
        "deviceType": deviceType,
        "url": url,
        "description": description,

    };

    wixData.insert("log", toInsert)
        .then((results) => {

        })
        .catch((err) => {
            let errorMsg = err;
        })
}
